<div class='container' [ngStyle]="{'padding': !isHandset? '' : '0'}">
  <div class="parent" *ngIf="(isAdmin && !isHandset) else mobileTemplate">
      <div class="grid">
        <span class="columnHeader" *ngFor="let t of columns">
          {{ t }}
        </span>
      </div>
      <div class="grid gridRow" *ngFor="let k of edits">
        <span class="whodunit">{{ k.createdByUser }}</span>
        <span class="dateTime">{{ k.createdDateTime | date:'long' }}</span>
        <span class="">{{ k.processUsed }}</span>
        <span>{{ k.actionTaken }}</span>
      </div>
    </div>
    <div class="recordCount">
      Showing the {{ edits?.length }} most recent log(s)
    </div>
</div>


<ng-template #mobileTemplate >

  <div class="parent mobile" *ngIf="isAdmin">
    <table classs="editHistory-table"> 
      <thead>
        <tr>
          <th *ngFor="let t of columns">{{ t }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let k of edits">
          <td class="whodunit">{{ k.createdByUser }}</td>
          <td class="dateTime">{{ k.createdDateTime | date:'long' }}</td>
          <td>{{ k.processUsed }}</td>
          <td>{{ k.actionTaken }}</td>
        </tr>
      </tbody>
    </table>


    <!-- <div class="grid">
      <span class="columnHeader" *ngFor="let t of columns">
        {{ t }}
      </span>
    </div>
    
    <div class="grid gridRow" *ngFor="let k of edits">
      <span class="whodunit">{{ k.createdByUser }}</span>
      <span class="dateTime">{{ k.createdDateTime | date:'long' }}</span>
      <span class="">{{ k.processUsed }}</span>
      <span>{{ k.actionTaken }}</span>
    </div>
  </div> -->
  <div class="recordCount">
    Showing the {{ edits?.length }} most recent log(s)
  </div>
  </div>

</ng-template>